import { List, TagField, useTable } from "@refinedev/antd";
import { Table, Breadcrumb, Button, Flex, Typography, App, Input, Spin, Space, Modal } from "antd";
import { useState, useEffect, useLayoutEffect, useRef  } from "react";
import { useResourceContext } from "@/layouts/ResourceContext";
import { getActionStepLog, downLoadActionStepLog, getStreamingLogName } from "@/apis";
import { RefreshButton } from "@/components/common/RefreshButton";
import { useInvalidate } from "@refinedev/core";
//import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';
import { io } from "socket.io-client";
import { useFormatter } from "@/hooks/useFormatter";

const { TextArea } = Input;

const handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
};
const getColumnSearchProps = (dataIndex, searchInput) => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
    <div
      style={{
        padding: 8,
      }}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <Input
        ref={searchInput}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
        style={{
          marginBottom: 8,
          display: 'block',
        }}
      />
      <Space>
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{
            width: 90,
          }}
        >
          Search
        </Button>
        <Button
          type="link"
          size="small"
          onClick={() => {
            close();
          }}
        >
          close
        </Button>
      </Space>
    </div>
  ),
  filterIcon: (filtered) => (
    <SearchOutlined
      style={{
        color: filtered ? '#1677ff' : undefined,
      }}
    />
  ),
 // onFilter: (value, record) =>
 //   record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
  onFilterDropdownOpenChange: (visible) => {
    if (visible) {
      setTimeout(() => searchInput.current?.select(), 100);
    }
  },

});

export const NodegroupAuditPanel = () => {
  const { state, dispatch } = useResourceContext();
  const [ selectedInstance ] = state.selectedResources;
  
  return selectedInstance?<AuditPanel key={selectedInstance.id} selectedId={selectedInstance.id} type="nodegroup"/>:null;
}

export const InstanceAuditPanel = () => {
  const { state, dispatch } = useResourceContext();
  const [ selectedInstance ] = state.selectedResources;
  
  return selectedInstance?<AuditPanel key={selectedInstance.id} selectedId={selectedInstance.id} type=""/>:null;
}
const AuditPanel = ({selectedId, type}) => {
  const [history, setHistory] = useState("");
  const [actionId, setActionId] = useState("");
  const [drillINInsanceId, setDrillINId] = useState("");

 
  const initItems = [{title:(<a onClick={() => setHistory("")}>Action History</a>)}];
  const [items, setItems] = useState(initItems);
  const [viewLog, setViewLog] = useState(false);
  const [logs, setLogs] = useState([]);
  const [refreshId, setRefreshId] = useState(0);
  const drillInHistory = ({historyId, instanceId}) => {
    setItems(initItems.concat({title:historyId}));
    setHistory(historyId);
    setDrillINId(instanceId);
    setViewLog(false);
  };
  
  const showLog = (e, value, action, actionId) => {
    e.preventDefault();
    setActionId(actionId);
    setLogs(JSON.parse(value).map((item) => (item.key = item.name)&&item));
    setItems(initItems.concat([{title:(<a onClick={() => setViewLog(false)}>{history}</a>)},{title:action}]));
    setViewLog(true);
  };
  const invalidate = useInvalidate();
  return (
    <>
    {
      history.length > 0 && drillINInsanceId == selectedId ? (
        <div>
        <Flex justify="space-between" align="center">
          <Breadcrumb items={items} separator=">"/>
          {!viewLog && <RefreshButton onClick={() => {
            if(viewLog){
              setRefreshId(refreshId+1);
            } else {
              invalidate({
                resource: "audits",
                invalidates: ["list"],
              });
            }
          }}/>}
        </Flex>
        
        {
          viewLog?(<ActionLog logs={logs} actionId={actionId} refreshId={refreshId} type={type}></ActionLog>) : 
          (<ActionHistory historyid={history} onShowLog={showLog} type={type}/>)
        }
        </div>
      ) : (        
        <AuditHistory onDrillIn={drillInHistory} selectedInstance={selectedId} type={type}/>
      )
    }      
    </>
  );
};
const AuditHistory = ({onDrillIn, selectedInstance, type}) => {
  const { formatDateTime } = useFormatter();
  const invalidate = useInvalidate();
  const totalRef = useRef(0);
  const { tableProps} = useTable({resource:"audits",
    syncWithLocation: false,
    filters: {initial: [
      {field: "id",operator:"contains"},
      {field: "user",operator:"contains"},
      {field: "action",operator:"contains"},
      {field: "content",operator:"contains"},
      {field: "start_ts",operator:"contains"},
      {field: "end_ts",operator:"contains"},
      {field: "status",operator:"contains"},
    ]},
    pagination:{current:1, pageSize:10},
    sorters: {initial: []},
    meta:{id:selectedInstance, resType:type, _total_:totalRef.current}});
  const { Title } = Typography;
  totalRef.current = tableProps.pagination.total || totalRef.current;
  let title = `Action History (${totalRef.current})`;

  const drillIn = (value, e) => {
    e.preventDefault();
    onDrillIn({historyId:value, instanceId:selectedInstance});
  };

 const searchInput = useRef(null);

 const [ongoingLog, setOngoingLog] = useState("");
 const [loadingLog, setLoadingLog] = useState(false);
 const key = useRef(Math.random().toString(36).substr(2, 9));
 const socket = useRef(null);
 const messages = useRef([]);
 const currentStreamingId = useRef("");
 const [isOpen, setIsOpen] = useState(false);
 const textRef = useRef(null);
 const [currentAction, setCurrentAction] = useState("");
 const onShowOngoingLog = (e, value, action, actionId) => {
   e.preventDefault();
   setCurrentAction(action);
   setIsOpen(true);
   messages.current = [];
   setOngoingLog("");
   if(currentStreamingId.current != actionId){
     //reset
     key.current = Math.random().toString(36).substr(2, 9);    
   }
   onStreamingLog(actionId);
 };

 const onStreamingLog = async (id) => {
   currentStreamingId.current = id;
   const response = await getStreamingLogName(id, type);
   if(response.status == "OK"){
     socket.current = io(window.location.origin,{
       "path":"/api/v1/provision/socket.io",
       "query": "log_file=" + response.value + "&key=" + key.current,
       "transports": ["websocket"]
     });

     socket.current.on("connect_error", (err) => {
       // the reason of the error, for example "xhr poll error"
       console.log(">>>" + err.message);
     
       // some additional description, for example the status code of the initial HTTP response
       console.log(">>>" + err.description);
     
       // some additional context, for example the XMLHttpRequest object
       console.log(">>>" + err.context);
     });

     socket.current.on(key.current, function(msg) {
       if(messages.current.length == 5000){//show latest 5000 lines
         messages.current.shift();
       }
       const textarea = textRef.current.resizableTextArea.textArea;
       let diff = textarea.scrollHeight - textarea.scrollTop - textarea.offsetHeight;
       messages.current.push(msg.message);
       setOngoingLog(messages.current.join("\n"));
       if(diff < 10) {
        setTimeout(() => {
          textarea.scrollTop = textarea.scrollHeight;
        }, 200);        
      }
     });

   }
 };

 const onCloseStreaming = () => {
   if(socket.current != null){
     socket.current.disconnect();
     socket.current = null;
     setIsOpen(false);
   }
 };

  return (
    <div>
      <Flex justify="space-between" align="center">
        <Title level={5} >{title}</Title>
        <RefreshButton onClick={() => {
        invalidate({
          resource: "audits",
          invalidates: ["list"],
        });
      }}/>
      </Flex> 
      <div style={{paddingTop:"10px"}}>    
      <Table {...tableProps} rowKey="id" size="small" showSorterTooltip={{
          target: 'sorter-icon',
        }}>
        <Table.Column dataIndex="id" title="ID" 
          render={(value) => <a onClick={(e) => drillIn(value, e)}>{value}</a>}
          {...getColumnSearchProps('id',searchInput)}
        />
        <Table.Column dataIndex="user" title="User" {...getColumnSearchProps('user',searchInput)}/>
        <Table.Column dataIndex="action" title="Action" {...getColumnSearchProps('action',searchInput)}/>
        <Table.Column dataIndex="content" title="Content" {...getColumnSearchProps('content',searchInput)}/>
        <Table.Column dataIndex="start_ts" title="Start Time" 
          render={(value) => formatDateTime(value)}
          {...getColumnSearchProps('start_ts',searchInput)}
        />
        <Table.Column dataIndex="end_ts" title="End Time" 
          render={(value) => formatDateTime(value)}
          {...getColumnSearchProps('end_ts',searchInput)}
        />
        <Table.Column dataIndex="duration" title="Duration" sorter={(a, b) => a.duration - b.duration}/>
        <Table.Column
          dataIndex="status"
          title="Status"
          render={(value, record) => <><TagField value={value} /> {record.streaming == true && <a onClick={(e) => onShowOngoingLog(e, value, record.action, record.id)}>...</a>}</>}
          {...getColumnSearchProps('status',searchInput)}
        />
      </Table>
      <Modal
        title={`Progress of '${currentAction}'`}
        centered
        footer={
          <Button type="primary" onClick={onCloseStreaming}>
            Close
          </Button>
        }
        open={isOpen}
        onCancel={onCloseStreaming}
        maskClosable={false}
        width={800}
        height={600}
        resize="both"
        loading={loadingLog}
      >
        <TextArea value={ongoingLog} readOnly rows="25"
          style={{resize:"none", width:"100%",height:"100%"}}
          ref={textRef}/>
      </Modal>      
      </div>
    </div>
  );
};

const ActionHistory = ({historyid, onShowLog, type}) => {
  const { formatDateTime } = useFormatter();
  const totalRef = useRef(0);
  const { tableProps} = useTable({resource:"audits",
    syncWithLocation: false,
    filters: {initial: [
      {field: "action",operator:"contains"},
      {field: "content",operator:"contains"},
      {field: "start_ts",operator:"contains"},
      {field: "status",operator:"contains"},
    ]},
    pagination:{current:1, pageSize:10},
    sorters: {initial: []},
    meta:{type:"action", resType:type, id:historyid, _total_:totalRef.current}});
  totalRef.current = tableProps.pagination.total || totalRef.current;  
  const canCreate = false;
  const searchInput = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [currentAction, setCurrentAction] = useState("");
  const [ongoingLog, setOngoingLog] = useState("");
  const [loadingLog, setLoadingLog] = useState(false);
  const key = useRef(Math.random().toString(36).substr(2, 9));
  const socket = useRef(null);
  const messages = useRef([]);
  const currentStreamingId = useRef("");
  const textRef = useRef(null);
  const onShowOngoingLog = (e, value, action, actionId) => {
    e.preventDefault();
    setCurrentAction(action);
    setIsOpen(true);
    messages.current = [];
    setOngoingLog("");
    if(currentStreamingId.current != actionId){
      //reset
      key.current = Math.random().toString(36).substr(2, 9);    
    }
    onStreamingLog(actionId);
  };

  const onStreamingLog = async (id) => {
    currentStreamingId.current = id;
    const response = await getStreamingLogName(id, type);
    if(response.status == "OK"){
      socket.current = io(window.location.origin,{
        "path":"/api/v1/provision/socket.io",
        "query": "log_file=" + response.value + "&key=" + key.current,
        "transports": ["websocket"]
      });

      socket.current.on("connect_error", (err) => {
        // the reason of the error, for example "xhr poll error"
        console.log(">>>" + err.message);
      
        // some additional description, for example the status code of the initial HTTP response
        console.log(">>>" + err.description);
      
        // some additional context, for example the XMLHttpRequest object
        console.log(">>>" + err.context);
      });

      socket.current.on(key.current, function(msg) {
        if(messages.current.length ==5000){//show latest 5000 lines
          messages.current.shift();
        }
        const textarea = textRef.current.resizableTextArea.textArea;
        let diff = textarea.scrollHeight - textarea.scrollTop - textarea.offsetHeight;
        messages.current.push(msg.message);
        setOngoingLog(messages.current.join("\n"));
        if(diff < 10) {
          setTimeout(() => {
            textarea.scrollTop = textarea.scrollHeight;
          }, 200);        
        }
      });

    }
  };

  const onCloseStreaming = () => {
    if(socket.current != null){
      socket.current.disconnect();
      socket.current = null;
      setIsOpen(false);
    }
  };
  return (
    <List title="" canCreate={canCreate} breadcrumb="">
      <Table {...tableProps} rowKey="id" size="small" showSorterTooltip={{
          target: 'sorter-icon',
        }}>
        <Table.Column dataIndex="action" title="Action" {...getColumnSearchProps('action', searchInput)}/>
        <Table.Column dataIndex="content" title="Content" {...getColumnSearchProps('content', searchInput)}/>
        <Table.Column
          dataIndex="status"
          title="Status"
          render={(value) => <TagField value={value} />}
          {...getColumnSearchProps('status', searchInput)}
        />
        <Table.Column dataIndex="start_ts" title="Start Time" 
          render={(value) => formatDateTime(value)}
          {...getColumnSearchProps('start_ts', searchInput)}
        />
        <Table.Column dataIndex="cost" title="Duration" sorter={(a, b) => a.cost - b.cost}/>
        <Table.Column
          dataIndex="logs"
          title="Logs"
          render={(value, record) => record.status=="on-going" && record.streaming == true?<a onClick={(e) => onShowOngoingLog(e, value, record.action, record.id)}>...</a>:
                                           value?<a onClick={(e) => onShowLog(e, value, record.action, record.id)}>{JSON.parse(value).length}</a> : ""}
        />
      </Table>
      <Modal
        title={`Progress of '${currentAction}'`}
        centered
        footer={
          <Button type="primary" onClick={onCloseStreaming}>
            Close
          </Button>
        }
        open={isOpen}
        onCancel={onCloseStreaming}
        maskClosable = {false}
        width={800}
        height={600}
        loading={loadingLog}
      >
        <TextArea value={ongoingLog} readOnly rows="25"
          style={{resize:"none", width:"100%",height:"100%"}}
          ref={textRef}/>
      </Modal>
    </List>
  );
};

const ActionLog = ({logs, actionId, refreshId, type}) => {
  const [logtext, setLogtext] = useState("");
  const [logName, setLogName] = useState("");
  const [rowKeys, setRowKeys] = useState([logs[0].key]);
  const [isFetching, setFetching] = useState(false);
  useLayoutEffect(() => {
    const fetchLog = async () => {
      if(actionId && logName){
        try {
          setFetching(true);
          const response = await getActionStepLog(actionId, logName, type);
          setFetching(false);
          if (response.status === "OK") {
            const resValue = response.value;           
            setLogtext(resValue.join("\n"));
          } else {
            setLogtext("");
          }
        } catch (error) {
          console.error("get built-in users failed:", error);
        }
     }
    };

    fetchLog();
  }, [logName, actionId, refreshId]);

  useEffect(() => {
    onSelectRow(logs[0].name);
  }, [logs]);

  const columns = [
    {
      title: 'File',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Size',
      dataIndex: 'size',
      key: 'size',
    },
    {
      title: 'Lines',
      dataIndex: 'count',
      key: 'count',
    },
  ];

  const { notification  } = App.useApp();
  const download = () => {
    doDownload(logName);
  }
  const doDownload = async (name) => {
      
      try{
        const response = await downLoadActionStepLog(actionId, name, type);
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name+".zip");
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch(error) {
        notification.error({
          message: '',
          description:
            `Failed to download ${logName}. ${error}`,
            placement: 'topRight'
        });
      }
  };
  const downloadAll = () => {
    logs.forEach(element => {
      doDownload(element.name);
    });
  };

  const onSelectRow = (fileName) => {
    setRowKeys([fileName]);
    setLogName(fileName);
  };
  
  const { TextArea } = Input;
  return (
    <Flex vertical={false}>
          <Table dataSource={logs} 
                 columns={columns} 
                 size="small"
                 rowSelection={{
                  hideSelectAll: true,
                  type: "radio",
                  selectedRowKeys:rowKeys,
                  onSelect: (record, selected) => {
                    if (selected) {
                      onSelectRow(record.name);
                    }
                  },
                }}
                 onRow={(record) => ({
                  onClick: () => onSelectRow(record.name),
                })}/>

          <Flex vertical gap={10}>
            <Flex
            justify="center" 
            align="center"
            style={{
              height: 'calc(100% - 30px)',
            }}
          >
          <Spin spinning={isFetching} delay={500}>
          <TextArea value={logtext} readOnly rows="25" cols="170" style={{resize:"none"}}/>
          </Spin>
          </Flex><Flex gap="middle" justify="flex-end">
              <Button onClick={() => downloadAll()}>Download All logs</Button>
              <Button onClick={() => download()}>Download</Button>
            </Flex>
          </Flex>
      </Flex>
  );
};